import React from 'react'
import PropTypes from 'prop-types'
import { Field } from 'formik'
import { Switch } from 'oio-react'

const ConnectedSwitch = ({ name, ...inputProps }) => (
   <Field
      name={name}
      render={({ field }) => (
         <Switch name={name} {...field} {...inputProps} defaultChecked={field.value} />
      )}
   />
)

ConnectedSwitch.propTypes = {
   name: PropTypes.string.isRequired
}

export default ConnectedSwitch
